import _Button from "@material-ui/core/esm/Button";
import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import buttonsClasses from 'swag-client-common/styles/buttons.scss';
import { Color } from 'swag-client-common/components/ui/color';
import getNotificationText from 'swag-common/utils/product/get-notification-text-for-product-quantity.util';
import { getSupplierInStockQuantityBySize, getStockQuantityToShow } from 'swag-client-common/utils/product.utils';
import OutOfStockMessage from 'swag-client-common/components/ui/out-of-stock-message';
import { HiddenLabel } from 'swag-client-common/components/hidden-label';
import { multipleQuantityBlockSelector } from '../../../../../redux/related-product-builder-popup/related-product.selectors';
import { multipleQuantityBlockDispatcher } from '../../../../../redux/related-product-builder-popup/related-product.dispatchers';
import detailsClasses from '../details/details.scss';
import { MIN_RELATED_AMOUNT } from '../../../../../redux/related-product-builder-popup/product.utils';
import styles from './quantity-block-multiple-styles';
const QuantityBlockMultipleComponent = ({
  number,
  showPriceBreaks,
  variants,
  quantityPerSizeEnabled,
  size,
  totalQuantity,
  sizeIndex,
  errorText,
  onPriceBreakClick,
  onGeneralQuantityChange,
  onSingleQuantityChange,
  classes,
  stockLevelsByVariantSku,
  productIsAlwaysInStock,
  outOfStockThreshold
}) => /*#__PURE__*/React.createElement("div", {
  className: detailsClasses.block
}, /*#__PURE__*/React.createElement("h5", {
  className: detailsClasses.blockTitle
}, /*#__PURE__*/React.createElement("div", {
  className: detailsClasses.number
}, number), "I would like", ' ', /*#__PURE__*/React.createElement(HiddenLabel, {
  htmlFor: "relatedProductQuantity",
  label: "Quantity for related product:"
}), /*#__PURE__*/React.createElement("input", {
  id: "relatedProductQuantity",
  className: classnames(detailsClasses.pink, detailsClasses.inputSize),
  type: "number",
  min: "1",
  value: totalQuantity,
  onChange: e => onGeneralQuantityChange(e.target.value)
}), ' ', "printed"), showPriceBreaks && /*#__PURE__*/React.createElement("div", {
  className: detailsClasses.buttonContainerRight
}, /*#__PURE__*/React.createElement(_Button, {
  onClick: onPriceBreakClick,
  variant: "contained",
  className: classes.button
}, "Price Breaks")), /*#__PURE__*/React.createElement("div", {
  className: detailsClasses.errorMessage
}, !!errorText && errorText), /*#__PURE__*/React.createElement("div", {
  className: detailsClasses.subBlock
}, variants.map(variant => {
  const {
    name,
    color,
    variantIndex,
    quantities
  } = variant;
  const quantity = quantities && quantities[sizeIndex];
  const errorMessage = quantity && getNotificationText({
    quantityForCurrentItem: quantity,
    minQuantity: MIN_RELATED_AMOUNT,
    variants: [variant],
    stockLevelsByVariantSku,
    productIsAlwaysInStock
  });
  return /*#__PURE__*/React.createElement("div", {
    key: variantIndex
  }, variants.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: classnames(buttonsClasses.blackTextBorderedButton, detailsClasses.buttonContainerLeft, detailsClasses.colorButtonWrapper)
  }, /*#__PURE__*/React.createElement(Color, {
    color: color,
    className: detailsClasses.colorCircle
  }), /*#__PURE__*/React.createElement("span", {
    className: detailsClasses.colorName
  }, name)), quantityPerSizeEnabled ? /*#__PURE__*/React.createElement("div", {
    className: detailsClasses.sizesContainer
  }, size.options.map((sizeName, sizeIndex) => {
    var _variant$sizeSkus;
    const supplierInStockQuantity = getSupplierInStockQuantityBySize({
      isAlwaysInStock: productIsAlwaysInStock || (variant === null || variant === void 0 ? void 0 : variant.isAlwaysInStockVariant),
      variantSizeSkus: (_variant$sizeSkus = variant === null || variant === void 0 ? void 0 : variant.sizeSkus) !== null && _variant$sizeSkus !== void 0 ? _variant$sizeSkus : {},
      currentSizeName: sizeName,
      stockLevelsByVariantSku
    });
    const isOutOfStock = supplierInStockQuantity <= outOfStockThreshold;
    const value = quantities ? quantities[sizeIndex] : 0;
    const grayedOut = isOutOfStock && value === 0;
    const inputId = `relatedProductQuantityForSize-${sizeName}-${variantIndex}`;
    return /*#__PURE__*/React.createElement("div", {
      key: sizeIndex,
      className: detailsClasses.sizeItem
    }, /*#__PURE__*/React.createElement("span", {
      className: detailsClasses.input
    }, /*#__PURE__*/React.createElement(HiddenLabel, {
      htmlFor: inputId,
      label: `Quantity for related product ${sizeName} size:`
    }), /*#__PURE__*/React.createElement("input", {
      id: inputId,
      className: classnames(detailsClasses.pink, {
        [detailsClasses.grayedOut]: grayedOut
      }),
      disabled: grayedOut,
      type: "number",
      min: "0",
      value: value,
      onChange: e => onSingleQuantityChange(e.target.value, variantIndex, sizeIndex)
    })), /*#__PURE__*/React.createElement("span", {
      className: detailsClasses.label
    }, sizeName), /*#__PURE__*/React.createElement(OutOfStockMessage, {
      twoLines: true,
      showCompletelyOutOfStockMessage: true,
      inStockQuantity: getStockQuantityToShow({
        isOutOfStock,
        availableQuantity: supplierInStockQuantity,
        currentQuantity: value
      })
    }));
  })) : variants.length > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiddenLabel, {
    htmlFor: "relatedProductVariantTotalQuantity",
    label: "Quantity for related product variant:"
  }), /*#__PURE__*/React.createElement("input", {
    id: "relatedProductVariantTotalQuantity",
    className: detailsClasses.pink,
    type: "number",
    min: "0",
    value: quantities[sizeIndex],
    onChange: e => onSingleQuantityChange(e.target.value, variantIndex, sizeIndex)
  })), variants.length > 1 && !!errorMessage && /*#__PURE__*/React.createElement("div", {
    className: detailsClasses.errorMessage,
    "data-error": "errorMessage"
  }, errorMessage));
})));
export const QuantityBlockMultiple = connect(multipleQuantityBlockSelector, multipleQuantityBlockDispatcher)(withStyles(styles)(QuantityBlockMultipleComponent));